module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_kimono@3x-8e73d1961f735911b1855dc143bc433d.webp";